"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIEmptyState = _interopRequireDefault(require("UIComponents/empty/UIEmptyState"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIIllustration = _interopRequireDefault(require("UIComponents/image/UIIllustration"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H4"));

var EmptyState = function EmptyState(_ref) {
  var onClick = _ref.onClick,
      hasAdsWriteScope = _ref.hasAdsWriteScope;
  return _react.default.createElement(_UIEmptyState.default, {
    titleText: _react.default.createElement(_H.default, null, _react.default.createElement(_FormattedMessage.default, {
      message: "marketing.ads.emptyState.title"
    })),
    primaryContent: _react.default.createElement("div", null, _react.default.createElement("p", null, _react.default.createElement(_FormattedMessage.default, {
      message: "marketing.ads.emptyState.manageCampaigns"
    })), _react.default.createElement("p", null, _react.default.createElement(_FormattedMessage.default, {
      message: "marketing.ads.emptyState.audiences"
    })), _react.default.createElement("p", null, _react.default.createElement(_FormattedMessage.default, {
      message: "marketing.ads.emptyState.reporting"
    })), _react.default.createElement(_UITooltip.default, {
      disabled: hasAdsWriteScope,
      title: _react.default.createElement(_FormattedMessage.default, {
        message: "marketing.ads.insufficientPermissions"
      })
    }, _react.default.createElement(_UIButton.default, {
      use: "primary",
      onClick: onClick,
      disabled: !hasAdsWriteScope
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "marketing.ads.emptyState.connectButton"
    })))),
    secondaryContent: _react.default.createElement(_UIIllustration.default, {
      name: "add-on-ads",
      width: "100%"
    })
  });
};

EmptyState.propTypes = {
  onClick: _propTypes.default.func.isRequired,
  hasAdsWriteScope: _propTypes.default.bool.isRequired
};
var _default = EmptyState;
exports.default = _default;
module.exports = exports.default;